var _process$env$REACT_AP;
import { useCallback } from 'react';
import { KeyResolver } from 'buzz_lib_contexts';
const env = (_process$env$REACT_AP = process.env.REACT_APP_BUZZ_ENV) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : 'local';
const infraApiUrl = env === 'local' ? 'https://buzzinfradevelop.azurewebsites.net/api/' : undefined;
const keyResolver = new KeyResolver(infraApiUrl);
export const useHoldingMessage = () => {
  const getHoldingMessage = useCallback(async () => await keyResolver.get('HoldingMessage'), []);
  return {
    getHoldingMessage
  };
};